export default __webpack_public_path__ + "static/media/undraw_my_password_d6kg.53ce262a.png";